import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import './Footer.scss'
import invite from '../../../assets/images/scouts/invite.svg'
import deals from '../../../assets/images/scouts/deals.svg'
import refrels from '../../../assets/images/scouts/refrels.svg'
import contracts from '../../../assets/images/scouts/contracts.svg'

// footer component for the Scout section.
const FooterScoutMobile = ({ history, location }) => {
  return (
    <div className="scout-footer-section">
      <div
        className={`footer-list text-dark px-2 ${
          location?.pathname === '/scout/invite' || location?.pathname?.includes('invite') ? 'active' : null
        }`}
        onClick={() => history.push('/scout/invite')}
      >
        <img src={invite} alt="invite" />
        <Link to="/scout/invite">Invite</Link>
      </div>
      <div
        className={`footer-list text-dark px-2 ${location?.pathname === '/scout/deals' ? 'active' : null}`}
        onClick={() => history.push('/scout/deals')}
      >
        <img src={deals} alt="deals" />
        <Link to="/scout/referrals">Deals</Link>
      </div>
      <div
        className={`footer-list text-dark px-2 ${
          location?.pathname === '/scout/referrals' ? 'active' : null
        }`}
        onClick={() => history.push('/scout/referrals')}
      >
        <img src={refrels} alt="refrels" />
        <Link to="/scout/referrals">Referrals</Link>
      </div>
      <div
        className={`footer-list text-dark px-2 ${
          location?.pathname === '/scout/contracts' ? 'active' : null
        }`}
        onClick={() => history.push('/scout/contracts')}
      >
        <img src={contracts} alt="contracts" />
        <Link to="/scout/contracts">Contracts</Link>
      </div>
    </div>
  )
}

export default withRouter(FooterScoutMobile)
